<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification";
import CheckModal from "@/components/CheckModal";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import perfilSociodemograficoAPI from "../../../services/standards/perfilSociodemografico/perfilSociodemograficoAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Perfil sociodemográfico y condiciones de salud ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {
    return {
      title: "3.1.1 Perfil sociodemográfico y condiciones de salud",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "3.1.1 Perfil sociodemográfico y condiciones de salud",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/perfil-sociodemografico`,
        },

        {
          text: "Editar",
          active: true,
        },
      ],

      years: [],
      lista: [],
      file: null,
      loading: true,
      submitted: false,

      item: null,
      itemStatus: null,

      itemData: null,

      perfil: {
        period: null,
        ips: null,
        file: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(23)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    rangeYear() {
      const max = 2050;
      const min = 2019;

      for (let i = min; i <= max; i++) {
        this.years.push(i);
      }
      return this.years;
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 3)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.perfil.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.1/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.1/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.perfil.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    getList() {
      perfilSociodemograficoAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.loading = false;
          this.perfil = {
            period: response.data.period,
            ips: response.data.ips,
            file: response.data.file,
            companies_id: response.data.companies_id,
          };
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    async update() {
      try {
        this.submitted = true
        this.loading = true
        let response = await this.uploadDocument();
        if (response) {
          perfilSociodemograficoAPI
            .update(this.$route.params.id, {
              period: this.perfil.period,
              ips: this.perfil.ips,
              file: this.perfil.file,
              companies_id: this.perfil.companies_id,
            }).then((response) => {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 23,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Éxito!",
                      text: "Informacion actualizada con éxito!",
                      icon: "success",
                      type: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    this.$router.go(-1);
                  }, 1500);
                })
                .catch((error) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1500);
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.loading = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Error!",
              text: "¡No se ha podido actualizar!",
              icon: "warning",
              type: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            window.location.reload()
          }, 2000)
        }
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getItems();
    this.getList();
    this.getItemData();
    this.rangeYear();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row px-3">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-4">
                  <b-form-group id="cycle" label-for="cycle" class="col-md-2 px-2" label="Período">
                    <select required :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="perfil.period">
                      <b-form-select-option v-for="item in years" :value="item">
                        {{ item }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group id="cycle" label-for="cycle" class="col-md-5 px-2" label="IPS">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" required type="text"
                      v-model="perfil.ips" maxlength="50">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-5 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" required type="file" id="file"
                      ref="file" name="file" browse-text="Buscar" :placeholder="perfil.file
                        ? getFile(perfil.file)
                        : `Selecciona un archivo...`
                        " drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
